export enum TravelFiltersEnum {
  CoverageOfRescueCosts = 'coverageOfRescueCosts',
  LuggageInsurance = 'luggageInsurance',
  Nnw = 'nnw',
  Oc = 'oc',
  SportEquipmentInsurance = 'sportEquipmentInsurance',
  SportsInsurance = 'sportsInsurance',
  TreatmentCost = 'treatmentCost',
  UnlimitedMedicalTransport = 'unlimitedMedicalTransport',
}

export enum TravelFiltersLabelEnum {
  SportsInsurance = 'OC Sportowe',
  LuggageInsurance = 'Ubezpieczenie bagażu',
  SportEquipmentInsurance = 'Ubezpieczenie sprzętu sportowego',
  CoverageOfRescueCosts = 'Pokrycie kosztów ratownictwa',
  UnlimitedMedicalTransport = 'Transport medyczny bez limitu',
}
